export const ActionTypes = {
    SET_SWAP_TRACKER_SWAPS: "SET_SWAP_TRACKER_SWAPS"
};
